(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('Licences', Licences);

    Licences.$inject = ['$resource'];

    function Licences ($resource) {
        var resourceUrl =  'api/licences/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
